import * as React from "react";
import { DatePicker } from "../../../../../../../react-core/Datepicker/DatePicker";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { TaxFormType } from "../../../../../../../Wrap/Constants/Enums/Customer/TaxFormType";
import { TaxResidencyForPensionRelief } from "../../../../../../../Wrap/Constants/Enums/Customer/TaxResidencyForPensionRelief";
import { CountryCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CountryCode";
import { CustomerTaxResidencyModel } from "../../../../../../../Wrap/Models/Models/Customer/Regulatory/CustomerTaxResidencyModel";
import { TaxFormModel } from "../../../../../../../Wrap/Models/Models/Customer/Regulatory/TaxFormModel";
import { ContentDatePicker } from "../../../../../../Shared/Entities/Constants/DateConstants";
import { ClientRecordAction } from "../../Action/ClientRecordAction";
import {
    TaxFormTypeMap,
    RegulatoryTabs,
    TaxFormTypes,
    TaxResidencyForPensionReliefMap,
    TaxExemptionReasonMap,
    TaxExemptionReasons,
    TaxResidencyForPensionReliefTypes,
} from "../../Resource/RegulatoryContents";
import { SectionTable } from "../SectionTable";

interface ITaxFormSectionProps {
    customerid: number;
    data: Array<CustomerTaxResidencyModel>;
    hasReadWriteAccess: boolean;
}
interface ITaxFormSectionState {
    data: TaxFormModel;
    isLoading: boolean;
    taxExemptionModel: CustomerTaxResidencyModel;
    tempResidencyModel: CustomerTaxResidencyModel;
}
export class TaxFormSection extends FormComponent<ITaxFormSectionProps, ITaxFormSectionState> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            isLoading: false,
            taxExemptionModel: null,
            tempResidencyModel: null,
        };
    }
    componentDidMount() {
        this.getData();
        if (this.props.data?.some((x) => x?.Country == CountryCode.GBR)) {
            this.setState({ taxExemptionModel: this.props.data.find((x) => x?.Country == CountryCode.GBR), tempResidencyModel: this.props.data.find((x) => x?.Country == CountryCode.GBR) });
        }
    }

    getData() {
        this.setState({ isLoading: true });
        ClientRecordAction.getTaxForm(this.props.customerid, (val) => {
            this.setState({
                data: val,
                isLoading: false,
            });
        });
    }

    render() {
        const { data, isLoading, taxExemptionModel, tempResidencyModel } = this.state;
        if (isLoading) {
            return <PartLoading isLoading={true} />;
        }
        const columnConfigs = [
            { title: "Forms", data: TaxFormTypeMap[data?.FormType] },
            { title: "Do you have this form?", data: data?.HasForm ? "Yes" : "No" },
        ];
        if (data && data.ExpiryDate && data.FormType == TaxFormType.W8BEN) {
            columnConfigs.push({
                title: "Expiry Date",
                data: JsonDateParser.getFormatDate(data.ExpiryDate, "dd/MM/yyyy"),
            });
        }
        if (this.state.taxExemptionModel) {
            columnConfigs.push(
                {
                    title: "Tax residency for pension relief",

                    data: taxExemptionModel?.TaxResidencyForPensionRelief
                        ? TaxResidencyForPensionReliefMap[taxExemptionModel?.TaxResidencyForPensionRelief]
                        : null,
                },
                {
                    title: "Tax exempt?",
                    data: taxExemptionModel?.TaxExempt ? (taxExemptionModel?.TaxExempt ? "Yes" : "No") : null,
                },
                {
                    title: "Exemption reason",
                    data: taxExemptionModel?.TaxExempt
                        ? TaxExemptionReasonMap[taxExemptionModel?.TaxExemptionReason]
                        : "",
                }
            );
        }
        return (
            <>
                    <SectionTable
                    sectionHeader={RegulatoryTabs.TaxForm}
                    columnConfigs={columnConfigs}
                    lightboxContent={(data, onDataChange) => this.renderLightBox(data, taxExemptionModel, tempResidencyModel,  onDataChange)}
                    onSave={(data) => this.onSave(data, taxExemptionModel, tempResidencyModel)}
                    onRemove={() => this.onRemove()}
                    data={data}
                    canEdit={this.props?.hasReadWriteAccess == true}
                />
            </>
        );
}

renderLightBox(data: TaxFormModel, taxExemptionModel: CustomerTaxResidencyModel, tempResidencyModel: CustomerTaxResidencyModel, onDataChange): JSX.Element {
        const displayExpiryDate = data && data.FormType == TaxFormType.W8BEN;
        return (
            <>
                <SelectEditor
                    options={TaxFormTypes}
                    getText={(v) => TaxFormTypeMap[v]}
                    label={"Form type"}
                    placeholder={"Please select"}
                    selected={data?.FormType}
                    cssWrapper="control-size-430"
                    onChange={(v) => {
                        onDataChange({ FormType: v, HasForm: null, ExpiryDate: null });
                    }}
                />
                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={"Do you have this form?"}
                    selected={data?.HasForm}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) => onDataChange({ HasForm: v })}
                    required={"Please select"}
                />
                {displayExpiryDate && (
                    <DatePicker
                        selected={JsonDateParser.toDateNoOffset(data?.ExpiryDate)}
                        label={"Expiry date"}
                        showYearDropdown={true}
                        required={displayExpiryDate ? "required" : null}
                        onChange={(v) => {
                            onDataChange({ ExpiryDate: JsonDateParser.toJsonDateNoOffset(v) });
                        }}
                        todayButton={ContentDatePicker.Today}
                        isClearable={true}
                        dateFormat={ContentDatePicker.DateFormat}
                    />
                )}
                <SelectEditor
                    options={TaxResidencyForPensionReliefTypes}
                    getText={(v) => TaxResidencyForPensionReliefMap[v]}
                    label={"Tax residency for pension relief"}
                    selected={
                        taxExemptionModel
                            ? taxExemptionModel.TaxResidencyForPensionRelief
                            : TaxResidencyForPensionRelief.Unknown
                    }
                    cssWrapper="control-size-430"
                    onChange={(v) => {
                        this.onTaxExemptionModelChange("TaxResidencyForPensionRelief", v);
                    }} />

                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={"Client tax exempt?"}
                    selected={taxExemptionModel?.TaxExempt}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) => {
                        this.onTaxExemptionModelChange("TaxExempt", v);
                    }} />
                
                {tempResidencyModel?.TaxExempt && (
                    <SelectEditor
                        options={TaxExemptionReasons}
                        getText={(v) => TaxExemptionReasonMap[v]}
                        label={"Tax exemption reason"}
                        required={"Please select"}
                        placeholder={"Please select"}
                        selected={taxExemptionModel?.TaxExemptionReason}
                        cssWrapper="control-size-430"
                        onChange={(v) => {
                            this.onTaxExemptionModelChange("TaxExemptionReason", v);
                        }}
                    />
                )}
</>
);
}

private onTaxExemptionModelChange(key: string, value: any) {
        const { tempResidencyModel } = this.state;
        let _data = JSON.parse(JSON.stringify(tempResidencyModel ? tempResidencyModel : {}));
        if (!_data) {_data = {};}
        _data[key] = value;
        if (key == "TaxExempt" && value == false) {
            _data["TaxExemptionReason"] = null;
        }
    this.setState({ tempResidencyModel: _data });
    }

    onSave(item: TaxFormModel, taxExemptionModel: CustomerTaxResidencyModel, tempResidencyModel: CustomerTaxResidencyModel): boolean {
        if (this.isValid()) {
            taxExemptionModel.TaxResidencyForPensionRelief = tempResidencyModel.TaxResidencyForPensionRelief;
            taxExemptionModel.TaxExempt = tempResidencyModel.TaxExempt;
            taxExemptionModel.TaxExemptionReason = tempResidencyModel.TaxExemptionReason;

            this.saveData(item, taxExemptionModel);
            return true;
        }
        return false;
    }

onRemove(): boolean {
        this.setState({ data: null });
        const model = this.state.taxExemptionModel;
        model.TaxExempt = null;
        model.TaxExemptionReason = null;
        model.TaxResidencyForPensionRelief = null;
        this.saveData(null, model);
        return true;
    }

saveData(data: TaxFormModel, taxExemptionModel: CustomerTaxResidencyModel) {
        ClientRecordAction.saveTaxForm(this.props.customerid, data, (val) => {
            const customerTaxResidencies = this.props.data.filter((x) => x?.Country != CountryCode.GBR);
            customerTaxResidencies.push(taxExemptionModel);
            ClientRecordAction.saveCutomerTaxResidency(this.props.customerid, customerTaxResidencies, () => {
                this.getData();
            });
        });
    }
}
